import moment from 'moment'

export default function (eventSeasonSettings, startdate){

	if(eventSeasonSettings) {
		const { templateReleaseDays } = eventSeasonSettings
		const eventdate = moment(startdate)
		const releaseDate = eventdate.subtract(templateReleaseDays, "days")
		return moment(releaseDate).format('LL')
	}
		return ''
}


// WEBPACK FOOTER //
// ./src/containers/event/EventWizard/EventTemplate/Logic/downloadAvailableDate.js